import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const TRANSLATION_KEY = "Instruction.string";

export function Instruction(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  const INSTRUCTION = t(TRANSLATION_KEY);

  return <span className={props.className}>{INSTRUCTION}</span>;
}

Instruction.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
};

Instruction.defaultProps = {};
